import { createBrowserHistory } from 'history';
const history = createBrowserHistory({basename: document.getElementsByTagName('base')[0].getAttribute('href')});
export default history;
